import styled from "styled-components";
import { BodyDefault } from "../typography/styled";
type ContainerProp = {
  customStyles?:any,
}
type CounterWrapperProp = {
  $compact?:boolean,
}
export const Container = styled.div<ContainerProp>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${({customStyles}) => customStyles}
`

export const CounterWrapper = styled.div<CounterWrapperProp>`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-top: 4px;
  padding: 0px 10px;
  min-width: ${({$compact}) => $compact ? '95px' : '160px'};
  height: 40px;
  background-color: ${({theme}) => theme.palette[10]};
  border:${({theme}) => `1px solid ${theme.grey[350]}`};
  border-radius: ${({theme}) => theme.radius.control};
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    border-color: ${({theme}) => theme.accent[100]};
  }

  &:focus-within {
    border-color: ${({theme}) => theme.accent[100]};
    box-shadow: ${({theme}) => theme.isDark ? theme.shadows.focusDark : theme.shadows.focus};
  }
`

export const Input = styled.input`
  width: 45px;
  border:none;
  outline: none;
  background-color: ${({theme}) => theme.palette[10]};
  color: ${({theme}) => theme.palette[900]};
  font-weight: 400;
  font-size: 15px;
  line-height: 20px;
  appearance: none;
  -moz-appearance: textfield; /* Firefox */
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    display: none;
  }
  &:focus{
    border: none;
    box-shadow: none;
  }
  &:active{
    border: none;
    box-shadow: none;
  }
`
export const StyledText = styled(BodyDefault)`
  color:${({theme}) => theme.palette[600]};
`
